import ResturantIconSvg from '@mui/icons-material/LocalDiningOutlined';
import MuseumIconSvg from '@mui/icons-material/MuseumOutlined';
import FitnessCenterOutlinedIcon from '@mui/icons-material/FitnessCenterOutlined';


// Contact info icons
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import LinkOutlinedIcon from '@mui/icons-material/InsertLinkOutlined';


// single job page
import LocationIcon from '@mui/icons-material/FmdGoodOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';

import TimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';

import PersonIcon from '@mui/icons-material/PersonOutlineOutlined';

import FullscreenIcon from '@mui/icons-material/ScreenshotMonitorOutlined';

export const Currency="Rs.";

export const AllResturantData=[
{
    tag:"FEATURED",
    image:"https://images.unsplash.com/photo-1555992457-b8fefdd09069?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    category:"Resturant",
    categoryIconSvg:<ResturantIconSvg className='font-2 text-color-white '></ResturantIconSvg>,
    isOpenNow:true,
    Name:"Food Corner",
    StarCount:4,
    Reviews:"02",
    startPirce:"05.00",
    endPrice:"80.00",
    phoneNumber:"+94 76 487 7823",
    loacation:"Colombo,Sri lanka",
    IsSaved:true,
},
{
    tag:"FEATURED",
    image:"https://images.unsplash.com/photo-1618604440689-d5465097c6a0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    category:"Museum",
    categoryIconSvg:<MuseumIconSvg className='font-2 text-color-white '></MuseumIconSvg>,
    isOpenNow:true,
    Name:"Food Corner",
    StarCount:4,
    Reviews:"02",
    startPirce:"05.00",
    endPrice:"80.00",
    phoneNumber:"+94 76 487 7823",
    loacation:"Colombo,Sri lanka",
    IsSaved:true,
},
{
    tag:"FITNESS",
    image:"https://th.bing.com/th/id/R.afc1a52ea76b1c8e1cb6d6f0ae9f607b?rik=%2fUJ53R8pvLThbA&pid=ImgRaw&r=0",
    category:"Fitness",
    categoryIconSvg:<FitnessCenterOutlinedIcon className='font-2 text-color-white '></FitnessCenterOutlinedIcon>,
    isOpenNow:false,
    Name:"Food Corner",
    StarCount:4,
    Reviews:"02",
    startPirce:"05.00",
    endPrice:"80.00",
    phoneNumber:"+94 76 487 7823",
    loacation:"Colombo,Sri lanka",
    IsSaved:true,
},
  
]


// Single resturant Data
export const SingleResturantData={
      resturantName:"Happy Hour",
      resturantBannerImg:"https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
      resturantBannerText:{
          line1:"staeters special offer",
          line2:"mix starters menu $18 only",
          line3:"hamburger, chips,Mix sausages, Beer,Muffin ",
      },
      AllRecipes:[
          {
              recipeImg:"https://images.unsplash.com/photo-1585238342024-78d387f4a707?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=580&q=80",
              recipeName:"Soft Shell crab",
              recipeIngredients:"chicken,potato,salad",
              recipePrice:"$14",
          },
          {
              recipeImg:"https://images.unsplash.com/photo-1546069901-ba9599a7e63c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80",
              recipeName:"Soft Shell crab",
              recipeIngredients:"chicken,potato,salad",
              recipePrice:"$14",
          },
          {
              recipeImg:"https://images.unsplash.com/photo-1639744211106-6dd155bd96b6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80",
              recipeName:"Soft Shell crab",
              recipeIngredients:"chicken,potato,salad",
              recipePrice:"$14",
          },
          {
              recipeImg:"https://images.unsplash.com/photo-1572449043416-55f4685c9bb7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=580&q=80",
              recipeName:"Soft Shell crab",
              recipeIngredients:"chicken,potato,salad",
              recipePrice:"$14",
          },
          {
              recipeImg:"https://images.unsplash.com/photo-1625944228741-cf30983ecb91?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=581&q=80",
              recipeName:"Soft Shell crab",
              recipeIngredients:"chicken,potato,salad",
              recipePrice:"$14",
          },
          {
              recipeImg:"https://images.unsplash.com/photo-1546069901-ba9599a7e63c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=580&q=80",
              recipeName:"Soft Shell crab",
              recipeIngredients:"chicken,potato,salad",
              recipePrice:"$14",
          },
      ],
  };



export const AllbuissnessData=[
   { 
       buissnessImage:"https://images.unsplash.com/photo-1516146544193-b54a65682f16?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
       buissnessName:"Art & Design",
       description:"Lorem, ipsum dolor sit amet consectetummodi quidem facere iste mollitia iusto.",
       location:"Negambo,Colombo",
       number:"079 586 8345",
       website:"www.myArtq.lk",
       ratingsStarCount:"4.5",
       reviewsCount:"27",
       IsFavourited:true,
    },
   { 
       buissnessImage:"https://images.unsplash.com/photo-1517971129774-8a2b38fa128e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=388&q=80",
       buissnessName:"Education",
       description:"Lorem, ipsum doletur adipisicing elit. Iure accusantium optio consectetur repudiandae perspiciatis commodi quidem facere iste mollitia iusto.",
       location:"Negambo,Colombo",
       number:"079 586 8345",
       website:"www.myArtq.lk",
       ratingsStarCount:"4.5",
       reviewsCount:"27",
    },
   { 
       buissnessImage:"https://images.unsplash.com/photo-1553531384-cc64ac80f931?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=80",
       buissnessName:"Documentary",
       description:"Lorem, ipsum dolor sit amet consectetur adipisicinoptio consectetur repudiandae perspiciatis commodi quidem facere iste mollitia iusto.",
       location:"Negambo,Colombo",
       number:"079 586 8345",
       website:"www.myArtq.lk",
       ratingsStarCount:"4.5",
       reviewsCount:"27",
    },
   { 
       buissnessImage:"https://images.unsplash.com/photo-1516146544193-b54a65682f16?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
       buissnessName:"Art & Design",
       description:"Lorem, ipsum dolor sit amet conse consectetur repudiandae perspiciatis commodi quidem facere iste mollitia iusto.",
       location:"Negambo,Colombo",
       number:"079 586 8345",
       website:"www.myArtq.lk",
       ratingsStarCount:"4.5",
       reviewsCount:"27",
    },
   { 
       buissnessImage:"https://images.unsplash.com/photo-1516146544193-b54a65682f16?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
       buissnessName:"Art & Design",
       description:"Lorem, i",
       location:"Negambo,Colombo",
       number:"079 586 8345",
       website:"www.myArtq.lk",
       ratingsStarCount:"4.5",
       reviewsCount:"27",
    },
   { 
       buissnessImage:"https://images.unsplash.com/photo-1516146544193-b54a65682f16?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
       buissnessName:"Art & Design",
       description:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iure accusantium optio consectetur repudiandae perspiciatis commodi quidem facere iste mollitia iusto.",
       location:"Negambo,Colombo",
       number:"079 586 8345",
       website:"www.myArtq.lk",
       ratingsStarCount:"4.5",
       reviewsCount:"27",
    },
   { 
       buissnessImage:"https://images.unsplash.com/photo-1516146544193-b54a65682f16?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
       buissnessName:"Art & Design",
       description:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iure accusantium optio consectetur repudiandae perspiciatis commodi quidem facere iste mollitia iusto.",
       location:"Negambo,Colombo",
       number:"079 586 8345",
       website:"www.myArtq.lk",
       ratingsStarCount:"4.5",
       reviewsCount:"27",
    },

  
]


export const AllDistricts= [  
    'Ampara',
  'Anuradhapura',
  'Badulla',
  'Batticaloa',
  'Colombo',
  'Galle',
  'Hambantota', 
  'Jaffna',
  'Kaluta',
   'Kandy', 
   'Kegalle', 
   'Kilinochchi', 
  'Kurunegala', 
   'Mannar', 
   'Matale', 
   'Matara', 
   'Monaragala', 
   'Mullaitivu',
  'Nuwara Eliya',
  'Polonnaruwa',
   'Puttalam',
   'Ratnapura',
   'Trincomalee', 
  'Vavuniva', 
  ];


// All JOBS PAGE


// filter --> 

export const AllJobsFilterByTitle=[
        {
            Text:"Web Designer",
            number:"12",

        },
        {
            Text:"3D Graphic Designer",
            number:"12",

        },
        {
            Text:"Graphic Designer",
            number:"17",

        },
        {
            Text:"Electronics Technician",
            number:"12",

        },
        {
            Text:"Web/Graphic Designer",
            number:"15",

        },
        {
            Text:"Brand Maneger",
            number:"33",

        },
    ];



export const AllJobsFilterByCity= [  

    {
        number:20,
            Text:'Ampara'
            },
    
        
        {number:20,
        Text:'Anuradhapura'
        },
    
    {
        number:20,
    Text:'Badulla'},
        

    {
        number:20,
    Text:'Batticaloa'
    },
        

    {
        number:20,
    Text:'Colombo'
    },
        

    {
        number:20,
            Text:'Galle'
    },
        

    
    {
        number:20, 
        Text:'Hambantota'
    }, 

    {
        number:20, 
        Text:'Jaffna'}, 
    
      
            
    {
        number:20, 
    Text:'Kaluta'},
        
        
    {
        number:20, 
        Text:'Kandy'
    }, 
    
    {
        number:20, 
        Text:'Kegalle'
    }, 
    
    {
        number:20, 
        Text:'Kilinochchi'
    }, 
    
    {
        number:20, 
        Text:'Kurunegala'
    }, 
    
    {
        number:20, 
        Text:'Mannar'
    }, 
    
    {
        number:20, 
        Text:'Matale'
    }, 
    
    {
        number:20, 
        Text:'Matara'
    }, 
    
    {
        number:20, 
        Text:'Monaragala'
    }, 
    
    {
        number:20, 
        Text:'Mullaitivu'
    },
    {

        number:20,
        Text: 'Nuwara Eliya',
    },

    
    {
        number:20, 
    Text:'Polonnaruwa'},
    
    {
        number:20, 
    Text:'Puttalam'},
    
    {
        number:20, 
    Text:'Ratnapura'},
    
    {
        number:20, 
    Text:'Trincomalee'}, 
    
    {
        number:20, 
    Text:'Vavuniva'}, 


    ];



export const AllJobsFilterByExperince=[
{
    Text:"Full Time/Permenet",
    number:"12",
},
{
    Text:"Contract",
    number:"33",
},
{
    Text:"Part TIme",
    number:"33",
},
{
    Text:"IntenShip",
    number:"33",
},

];

// all profiles details 

export const AllJobProfiles=[
    {
      personImg:"https://www.befunky.com/images/wp/wp-2021-01-linkedin-profile-picture-professional-attire.jpg?auto=webp&format=jpg&width=944",
      personName:"Jhon Doe",
      job:"Java Developer",
      location:"Colombo,Sri lanka",
      price:"$5000",
      priceDuration:"month",
      Description:`Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eius, eos vel temporibus expedita fugit at praesentium iure est nostrum corrupti.eos vel temporibus expedita fugit at praesentium iure est nostrum corrupti`,

    },
    {
      personImg:"https://www.befunky.com/images/wp/wp-2021-01-linkedin-profile-picture-professional-attire.jpg?auto=webp&format=jpg&width=944",
      personName:"Jhon Doe",
      job:"Java Developer",
      location:"Colombo,Sri lanka",
      price:"$5000",
      priceDuration:"month",
      Description:`Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eius, eos vel temporibus expedita fugit at praesentium iure est nostrum corrupti.`,

    },
    {
      personImg:"https://www.befunky.com/images/wp/wp-2021-01-linkedin-profile-picture-professional-attire.jpg?auto=webp&format=jpg&width=944",
      personName:"Jhon Doe",
      job:"Java Developer",
      location:"Colombo,Sri lanka",
      price:"$5000",
      priceDuration:"month",
      Description:`Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eius, eos vel temporibus expedita fugit at praesentium iure est nostrum corrupti.`,

    },
]


// Single Buissness

export const SingleBuissnessData={
    BuissnessName:"Bizdire University",
    ReviewsCount:4,
    socialMediaLinks:{
        facebook:"https://www.facebook.com/computerprofessionals/",
        twitter:"https://twitter.com/Oozoids",
        rss:"",
        youtube:"",
        linkdin:"",
    },
    location:"malabe,colombo,sri lanka",
    phoneNumber:"077 2456 790",
    imgSliderSection:{
        images:[
            "https://www.spruko.com/demo/bizdire/Bizdire/assets/images/products/products/ed1.jpg",
            "https://www.spruko.com/demo/bizdire/Bizdire/assets/images/products/products/ed2.jpg",
            "https://www.spruko.com/demo/bizdire/Bizdire/assets/images/products/products/ed9.jpg",
            "https://www.spruko.com/demo/bizdire/Bizdire/assets/images/products/products/ed8.jpg",
            "https://www.spruko.com/demo/bizdire/Bizdire/assets/images/products/products/ed1.jpg",
            "https://www.spruko.com/demo/bizdire/Bizdire/assets/images/products/products/ed2.jpg",
            "https://www.spruko.com/demo/bizdire/Bizdire/assets/images/products/products/ed10.jpg",
            "https://www.spruko.com/demo/bizdire/Bizdire/assets/images/products/products/ed9.jpg",
            "https://www.spruko.com/demo/bizdire/Bizdire/assets/images/products/products/ed10.jpg",
        ],
        buissnessDescriptionTop:{
            category:"Education",
            location:"Sri lanka",
            time:"5 hours ago",
            views:"765",
            reviews:"4.0",
            favCount:"135",
        },
        price:"$539",
        overView:`
                              
                   
                    porro earum consequatur? Delectus ut eos aut, cumque eligendi vel odio quibusdam ipsa accusantium commodi in error quos deleniti. Earum.
                    porro earum consequatur? Delectus ut eos aut, cumque eligendi vel odio quibusdam ipsa accusantium commodi in error quos deleniti. Earum.
                    porro earum consequatur? Delectus ut eos aut, cumque eligendi vel odio quibusdam ipsa accusantium commodi in error quos deleniti. Earum.

                    porro earum consequatur? Delectus ut eos aut, cumque eligendi vel odio quibusdam ipsa accusantium commodi in error quos deleniti. Earum.
                    porro earum consequatur? Delectus ut eos aut, cumque eligendi vel odio quibusdam ipsa accusantium commodi in error quos deleniti. Earum.
                

        `,
        contactSection:[
            {
                svgIcon:<MapOutlinedIcon className='contact-icon  border-radius-circle p-2 font-2-9 '></MapOutlinedIcon>,
                text:"Mp-214, New York, NY 10012"
            },

            {
                svgIcon:<CallOutlinedIcon className='contact-icon  border-radius-circle p-2 font-2-9 '></CallOutlinedIcon>,
                text:"076 5842 789"
            },
            {
                svgIcon:<MailOutlinedIcon className='contact-icon  border-radius-circle p-2 font-2-9 '></MailOutlinedIcon>,
                text:"spruko123@gmail.com"
            },
            {
                svgIcon:<LinkOutlinedIcon className='contact-icon  border-radius-circle p-2 font-2-9 '></LinkOutlinedIcon>,
                text:"spruko123@gmail.com"
            },
        ],

        moreBuissnessInfo:[
            {
                text:"Established Year",
                info:"1981"
            },
            {
                text:"Services",
                info:"Education, courses"
            },
            {
                text:"payment methods",
                info:"visa,master,discovery,american express"
            },
            {
                text:"fax",
                info:"+25 485-9865-85"
            },
            {
                text:"TollFree",
                info:"+25 458-9865-85"
            },
            {
                text:"certififaction",
                info:"ISO certified"
            },
        ],

        buissnessId:'#8256358',
        postedDate:'21 Des 2019',


        RelatedPost:[
            {
                "image":"https://www.spruko.com/demo/bizdire/Bizdire/assets/images/products/products/ed1.jpg",
                "category":"Education",
                "reviewStarCount":3,
                "BuissnesName":"Record Writing",
                "isVerfiifed":true,
                "otherInfo":{
                    "location":"sri lanka",
                    "createdTime":"2 hours ago",
                    "owner":"Clara perera",
                    "phone":"076 589 5246",

                },
                
            },
            {
                "image":"https://www.spruko.com/demo/bizdire/Bizdire/assets/images/products/products/ed2.jpg",
                "category":"Education",
                "reviewStarCount":3,
                "BuissnesName":"Record Writing",
                "isVerfiifed":true,
                "otherInfo":{
                    "location":"sri lanka",
                    "createdTime":"2 hours ago",
                    "owner":"Clara perera",
                    "phone":"076 589 5246",

                },
                
            },
        ],

        RatingsAndReviews:[
            {
                rateComp:  5,
                barContent: <div className='bar-content text-color-white fw-bold  font-1-2 '>19536556</div>,
                ratingBarWidth:"90%",
                color:"#10d403",
            },

            {
                rateComp:  4,
                barContent: <div className='bar-content text-color-white fw-bold  font-1-2 '>195356</div>,
                ratingBarWidth:"70%",
                color:"#0ab2e6",
            },
            {
                rateComp:  3,
                barContent: <div className='bar-content text-color-white fw-bold  font-1-2 '>1956</div>,
                ratingBarWidth:"40%",
                color:"#ff8819",
            },
            {
                rateComp:  2,
                barContent: <div className='bar-content text-color-white fw-bold  font-1-2 '>1956</div>,
                ratingBarWidth:"30%",
                color:"#00148e",
            },
            {
                rateComp:  1,
                barContent: <div className='bar-content text-color-white fw-bold  font-1-2 '>1956</div>,
                ratingBarWidth:"20%",
                color:"#e67605",
            },
            
        ],  

        Comments:[
            {
                img:"https://www.spruko.com/demo/bizdire/Bizdire/assets/images/faces/male/1.jpg",
                profileName:"Joanne Scott",
                isVerfiifed:true,
                time:"2 hours ago",
                commentDescription:" Lorem ipsum dolor sit amet, quis Neque porro quisquam est, nostrud exercitation ullamco laboris commodo consequat. ",
            },
            {
                img:"https://www.spruko.com/demo/bizdire/Bizdire/assets/images/faces/male/1.jpg",
                profileName:"Joanne Scott",
                isVerfiifed:true,
                time:"2 hours ago",
                commentDescription:" Lorem ipsum dolor sit amet, quis Neque porro quisquam est, nostrud exercitation ullamco laboris commodo consequat. ",
            },
            {
                img:"https://www.spruko.com/demo/bizdire/Bizdire/assets/images/faces/male/1.jpg",
                profileName:"Joanne Scott",
                isVerfiifed:true,
                time:"2 hours ago",
                commentDescription:" Lorem ipsum dolor sit amet, quis Neque porro quisquam est, nostrud exercitation ullamco laboris commodo consequat. ",
            },
            {
                img:"https://www.spruko.com/demo/bizdire/Bizdire/assets/images/faces/male/1.jpg",
                profileName:"Joanne Scott",
                isVerfiifed:true,
                time:"2 hours ago",
                commentDescription:" Lorem ipsum dolor sit amet, quis Neque porro quisquam est, nostrud exercitation ullamco laboris commodo consequat. ",
            },
        ],

        
        
    },


    col2Data:{
        buissnessName:"Robert McLean",
        buissnessImgLogo:"https://www.spruko.com/demo/bizdire/Bizdire/assets/images/other/logo.png",
        listenDate:"November 2008",
        listenId:"3645452",
        
        ContactDetails:{
            location:"malabe,colombo,sri lanka",
            emial:"spruko123@gmail.com",
            phone:"076 5462 496",
            webSiteLink:"https://spruko.com/",

        },

        timings:[
            {
                day:"Monday",
                time:"9.00am-9.00pm"
            },
            {
                day:"Tuesday",
                time:"9.00am-9.00pm"
            },
            {
                day:"Wednesday",
                time:"9.00am-9.00pm"
            },
            {
                day:"Friday",
                time:"9.00am-9.00pm"
            },
            {
                day:"Saturday",
                time:"9.00am-9.00pm"
            },
            {
                day:"Sunday",
                time:"9.00am-9.00pm"
            },

        ],

        location:"malabe,colombo,sri lanka",
        locationUrl:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31687.082210248744!2d79.94787966641846!3d6.904320329140168!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae256d59601df81%3A0x31a1dd96e8d49ba!2sMalabe!5e0!3m2!1sen!2slk!4v1647616453082!5m2!1sen!2slk",

        ownerDetails:{
            ownerImg:"https://www.spruko.com/demo/bizdire/Bizdire/assets/images/faces/female/13.jpg",
            ownerName:"Lilly Jones ",
            ownerRank:"Listing Owner",

            facebookLink:"https://www.facebook.com/computerprofessionals/",
            twitterLink:"https://www.facebook.com/computerprofessionals/",
            youtubeLink:"https://www.facebook.com/computerprofessionals/",
            pinterestLink:"https://www.pinterest.com/pin/1032239177062470147/",
         
         
            mobileNum:"https://www.facebook.com/computerprofessionals/",
        },

        searchList:[
            "-- Select Category --",
            "Real state",
            "resturant",
            "beauty",
            "jobs",
            "services",
            "event",
            "travel",
        ],

        recentPost: {
            image:"https://www.spruko.com/demo/bizdire/Bizdire/assets/images/products/products/ed1.jpg",
            category:"Education",
            reviewStarCount:3,
            BuissnesName:"Record Writing",
            isVerfiifed:true,
            otherInfo:{
                location:"sri lanka",
                createdTime:"2 hours ago",
                owner:"Clara perera",
                phone:"076 589 5246",

            },
            
        },


        
    }



}; 


//  Single Job

export const SingleJobPageData={



    Col1Data:{
        
        jobDetails:{
            jobImage:"http://utouchdesign.com/themes/envato/escort/assets/img/company_logo_1.png",
            jobName:"Web Designer",
            jobAdress:"512 Big Tower, Sri lanka",
            detailsList:[
                { 
                    icon:<CreditCardOutlinedIcon className='text-color-grey-light   font-1-8 '></CreditCardOutlinedIcon>,
                    text:"Package: 20K To 50/K Mouth",
                },
                { 
                    icon:<PhoneAndroidOutlinedIcon className='text-color-grey-light   font-1-8 '></PhoneAndroidOutlinedIcon>,
                    text:"079 7483 653",
                },
                { 
                    icon:<MailOutlinedIcon className='text-color-grey-light   font-1-8 '></MailOutlinedIcon>,
                    text:"mail@example.com",
                },
                { 
                    icon:<FullscreenIcon className='text-color-grey-light   font-1-8 '></FullscreenIcon>,
                    text:"Full Time",
                },
                { 
                    icon:<PersonIcon className='text-color-grey-light   font-1-8 '></PersonIcon>,
                    text:"7 Open Posiiton",
                },
                { 
                    icon:<CalendarMonthOutlinedIcon className='text-color-grey-light   font-1-8 '></CalendarMonthOutlinedIcon>,
                    text:"3 Year Exp.",
                },
            ],
        },

        jobDescription:{
            title:"Job Description",

            description:`
            On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound to ensue.

            At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga
            `,
        },

        jobSkill:{
            title:"Job Skill",

            list:[
                "Contrary to popular belief, Lorem Ipsum is not simply random text",
                "Latin professor at Hampden-Sydney College in Virginia",
                "looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage ideas",
                "The standard chunk of Lorem Ipsum used since the 1500s is reproduced",
                "accompanied by English versions from the 1914 translation by H. Rackham",
            ]

        },


        location:{
            title:"Location",
            mapLink:"https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6861.138534662161!2d76.821472!3d30.702393!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe4953728a502a8e2!2sChandigarh%20Junction%20railway%20station!5e0!3m2!1sen!2sin!4v1647861891675!5m2!1sen!2sin",

        },

        Requirments:{
            title:"Requirments",

            list:[
                "There are many variations of passages of Lorem Ipsum available",
                "the majority have suffered alteration in some form slightly",
                "you need to be sure there isn't anything embarrassing hidden",
                "generators on the Internet tend to repeat predefined chunks as necessary",
                "There are many variations of passages of Lorem Ipsum available",
                "the majority have suffered alteration in some form slightly",
                "you need to be sure there isn't anything embarrassing hidden",
                "making this the first true generator on the Internet It uses a dictionary",
            ]

        },

    },

    Col2Data:{
        location:{
            title:"Location",
            icon:<LocationIcon className='text-color-white this-comp-green border-radius-circle p-2 font-3-5 me-2 '></LocationIcon>,
            list:[
               { 
                   icon:<LocationIcon className='font-2 '></LocationIcon>,
                   text:"Package: 20K To 50/K Mouth",
                },
               { 
                   icon:<LanguageOutlinedIcon className='font-2 '></LanguageOutlinedIcon>,
                   text:"Package: 20K To 50/K Mouth",
                },
               { 
                   icon:<PhoneAndroidOutlinedIcon className='font-2 '></PhoneAndroidOutlinedIcon>,
                   text:"Package: 20K To 50/K Mouth",
                },
               { 
                   icon:<MailOutlinedIcon className='font-2 '></MailOutlinedIcon>,
                   text:"Package: 20K To 50/K Mouth",
                },
               { 
                   icon:<SchoolOutlinedIcon className='font-2 '></SchoolOutlinedIcon>,
                   text:"Package: 20K To 50/K Mouth",
                },
               { 
                   icon:<CalendarMonthOutlinedIcon className='font-2 '></CalendarMonthOutlinedIcon>,
                   text:"Package: 20K To 50/K Mouth",
                },
            ],
        },
        openingHours:{
            title:"Opening Hours",
            icon:<TimeOutlinedIcon className='text-color-white this-comp-green border-radius-circle p-2 font-3-5 me-2 '></TimeOutlinedIcon>,
            list:[

             {
                 text:"Monday",
                 time:"9 AM - 5 PM",
             },
             {
                 text:"Tuesday",
                 time:"9 AM - 5 PM",
             },
             {
                 text:"Wednesday",
                 time:"9 AM - 5 PM",
             },
             {
                 text:"Thursday",
                 time:"9 AM - 5 PM",
             },
             {
                 text:"Friday",
                 time:"9 AM - 5 PM",
             },
             {
                 text:"Saturday",
                 time:"9 AM - 5 PM",
             },
             {
                 text:"Sunday",
                 time:"9 AM - 5 PM",
             },

            ],
        },

        locationCol2:{
            title:"Location",
            icon:<LocationIcon className='text-color-white this-comp-green border-radius-circle p-2 font-3-5 me-2 '></LocationIcon>,
            mapLink:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31465.037656946886!2d80.01087411788409!3d9.66995710480245!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3afe53fd7be66aa5%3A0xc7da0d9203baf512!2sJaffna!5e0!3m2!1sen!2slk!4v1647885549438!5m2!1sen!2slk",

        },
    },

} ;





